<template>
	<div id="login" class="body-content">
    <div class="account-wrapper">
  		<div class="slogan-wrapper" v-show="requireLogin">
<!--  			<img src="/static/images/logo_index.png" alt="">-->
  			<span class="slogan-text">{{ $t("index.loginText") }}</span>
  		</div>
  		<div class="account-form" v-show="requireLogin">
  			<div class="form-row">
  				<input type="text" class="form-input" v-bind:class="{ 'input-require': nameValidate.invalidate }" v-model="username" :placeholder="$t('index.userName')">
  				<p class="text-error" v-if="nameValidate.emtpy">{{ $t("index. userTip") }}</p>
          <p class="text-error" v-if="nameValidate.format">{{ $t("index. errorFormat") }}</p>
          <p class="text-error" v-if="nameValidate.active">{{ $t("index. inactive") }} <span class="resend" @click="resend">{{ $t("index. resend") }}</span> <span v-if="reSend.success">{{ $t("index. success") }}</span></p>
  			</div>
  			<div class="form-row">
  				<input type="password" class="form-input" v-bind:class="{ 'input-require': pwdValidate.invalidate }" v-model="password" :placeholder="$t('index.password')" @keyup.enter="login">
  				<p class="text-error" v-if="pwdValidate.emtpy">{{ $t("index. pwdTip") }}</p>
  				<p class="text-error" v-if="loginResult.fail">{{ $t("index. loginFail") }}</p>
  			</div>
  			<div class="form-row btn-wrap">
  				<button class="czur-style" type="button" @click="login">{{ $t("index.loginText") }}</button>
  			</div>
        <!--<div class="form-row">
            <div class="lost-pass-wrapper">
            <span class="lost-pass-text" @click="findPwd">忘记密码</span>
          </div>
        </div>
  			<div class="form-row">
  				<button @click="register" type="button" class="registerBtn">注册成者账号</button>
  			</div>-->
        <div class="register-row">
          <ul class="clearfix">
            <li @click="findPwd"  class="forget-password">{{ $t("index.forgetPwd") }}</li>
            <li @click="register" class="user-register">{{ $t("index.register") }}</li>
          </ul>
        </div>
  		</div>
  		<loading :appear="processing"></loading>
  		<LoginCheck v-on:nologin="withOutLogin" v-on:islogin="alreadyLogin"></LoginCheck>
      <!-- 子系统登出接口,兼容跨域接口 -->
      <div class="logout-frame">
        <iframe v-for="api in logoutAPIs" :src="api" frameborder="0"></iframe>
      </div>
    </div>
	</div>
</template>

<script>
import Config from 'common/script/config.js'
import Validate from 'common/script/validate.js'
import MD5 from 'common/script/md5.js'
import loading from 'components/loading/loading'
import LoginCheck from 'components/loginCheck/loginCheck'

export default {
  name: 'login',
  data () {
    return {
      id: '',
      username: '',
      password: '',
      requireLogin: false,
      nameValidate: {
        emtpy: false,
        format: false,
        invalidate: false,
        active: false
      },
      reSend: {
        success: false
      },
      pwdValidate: {
        emtpy: false,
        format: false,
        invalidate: false
      },
      loginResult: {
        fail: false,
        msg: '用户名或密码错误'
      },
      processing: true,
      logoutAPIs: []
    }
  },
  created: function () {
    // 登出操作，获取需要登出的子系统
    if (Config.getReqParam('action') === 'logout') {
      Config.cookieSet(Config.COOKIE_KEY.U_ID, '')
      Config.cookieSet(Config.COOKIE_KEY.TOKEN, '')
      Config.cookieSet(Config.COOKIE_KEY.USER_NAME, '')
      this.$http.get(Config.passportHost + '/public/web/logout/list', {}).then((response) => {
        response = response.body
        this.logoutAPIs = response.body
      })
    }
  },
  components: {
    loading,
    LoginCheck
  },
  methods: {
    register: function () {
      window.location.href = 'register.html'
    },
    findPwd: function () {
      window.location.href = 'findPwd.html'
    },
    formCheck: function () {
      this.nameCheck()
      this.pwdCheck()
      return this.nameValidate.invalidate || this.pwdValidate.invalidate
    },
    nameCheck: function () {
      if (Validate.stringEmpty(this.username)) {
        this.nameValidate.emtpy = true
        this.nameValidate.invalidate = true
        this.nameValidate.format = false
      } else if (!Validate.validateEmail(this.username) && !Validate.isTel(this.username)) {
        this.nameValidate.emtpy = false
        this.nameValidate.invalidate = true
        this.nameValidate.format = true
      } else {
        this.nameValidate.emtpy = false
        this.nameValidate.invalidate = false
        this.nameValidate.format = false
      }
    },
    pwdCheck: function () {
      this.loginResult.fail = false
      if (Validate.stringEmpty(this.password)) {
        this.pwdValidate.emtpy = true
        this.pwdValidate.invalidate = true
      } else {
        this.pwdValidate.emtpy = false
        this.pwdValidate.invalidate = false
      }
    },
    login: function () {
      if (!this.formCheck()) {
        this.processing = true
        this.$http.post(Config.passportHost + '/login/', {
          'username': this.username,
          'password': MD5.hex_md5(this.password)
        }).then((response) => {
          this.processing = false
          response = response.body
          if (response.code === 1005) {
              this.nameValidate.active = true
              this.id = response.body
          } else if (response.code === Config.R_CODE.PWD_ERROR) {
            this.nameValidate.active = false
            this.loginResult.fail = true
            if (this.$i18n.locale === 'en') {
              this.loginResult.msg = 'wrong user name or password'
            } else if (this.$i18n.locale === 'zh_CN') {
              this.loginResult.msg = '用户名或密码错误'
            } else if (this.$i18n.locale === 'zh_TW') {
              this.loginResult.msg = '用戶名或密碼錯誤'
            }
          } else if (response.code === Config.R_CODE.SUCCESS) {
            // 登陆成功默认同意勾选cookie第一条
            localStorage.setItem('cookie_necessary', 1)
            localStorage.setItem('cookie_preference', 0)
            localStorage.setItem('cookie_statistics', 0)
            Config.cookieSet(Config.COOKIE_KEY.U_ID, response.body.id)
            Config.cookieSet(Config.COOKIE_KEY.TOKEN, response.body.token)
            Config.cookieSet(Config.COOKIE_KEY.USER_NAME, response.body.name)
            this.nameValidate.active = false
            var callback = Config.getReqParam('service')
            let passwordType = !Validate.passwordRule(this.password)
            if (!response.body.countryCode || response.body.countryCode === null || response.body.countryCode === 'null') {
              this.$router.push({path: '/country?pw=' + passwordType})
              return
            }
            if (!Validate.passwordRule(this.password)) {
              Config.setLocalStore('pw', 1)
              this.$router.push({path: '/resetPwd/low'})
              return
            }
            Config.setLocalStore('pw', 0)
            if (!Validate.stringEmpty(callback)) {
              callback = Config.appendParam(callback, 'token', response.body.token)
              callback = Config.appendParam(callback, 'u_id', response.body.id)
                // console.log(callback)
              window.location.href = callback
            } else {
              Config.setLocalStore('request_flag', 1)
              window.location.href = Config.DEFAULT_PAGE
            }
          }
        })
      }
    },
    withOutLogin: function () {
      this.requireLogin = true
      this.processing = false
    },
    alreadyLogin: function () {
      var callback = Config.getReqParam('service')
      if (!Validate.stringEmpty(callback)) {
        callback = Config.appendParam(callback, 'token', Config.cookieGet(Config.COOKIE_KEY.TOKEN))
        callback = Config.appendParam(callback, 'u_id', Config.cookieGet(Config.COOKIE_KEY.U_ID))
        // console.log(callback)
        window.location.href = callback
      } else {
        window.location.href = Config.DEFAULT_PAGE
      }
    },
   resend: function () {
      this.processing = true
      this.$http.post(Config.passportHost + '/public/web/register/resend', {
        'uId': this.id,
        'locale': Config.local4Service()
      }).then((response) => {
        this.processing = false
        response = response.body
        if (response.code !== 1000) {
            alert(response.msg)
        } else {
          this.reSend.success = true
          var itemThis = this
          window.setTimeout(function () {
            itemThis.reSend.success = false
           }, 3000)
        }
      })
  }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
#login
  .account-form
    .form-row
      margin-top 0
      margin-bottom 0
      min-height 0.6rem
      .text-error
        min-height .16rem
        line-height .16rem
      &.btn-wrap
        margin-top 0.28rem !important
.logout-frame
  width 0
  height 0
  overflow hidden
  opacity 0
.register-row
  font-size .12rem
  color #3d3d3d
  text-align center
  ul
    display flex
  .forget-password
    padding-right .15rem
    //border-right 1px solid #272f44
    cursor pointer
  .user-register
    margin-left auto
    padding-left .15rem
    cursor pointer
.resend
  color #272f44
  cursor pointer

@media screen and (max-device-width: 720px), (max-width: 720px)
  #login
    .account-form
      .form-row
        min-height 0.8rem
</style>



// WEBPACK FOOTER //
// login.vue?64b2d31c